import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { LinkH400 } from "../../NormalLink"
import LanguageSelector from "../../LanguageSelector"
import ApplyNowDrawer from "../../ApplyNowDrawer"
import { currentLocale } from "../../../locale/languages"
import MobileNavSubItems from "./MobileNavSubItems"
import slugify from "../../../utils/slugify"
import localeData from "../../../locale"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 80px;
  background-color: ${(props) => props.theme.colors.white};
`

const Item = styled(LinkH400)`
  padding: 16px;
  text-align: center;
  display: block;
  &.active {
    color: ${(props) => props.theme.colors.orange800};
    &:hover {
      color: ${(props) => props.theme.colors.orange800};
    }
  }
  &:hover {
    color: ${(props) => props.theme.colors.black400};
  }
`
const Footer = styled.div`
  background-color: ${(props) => props.theme.colors.black100};
  padding: 28px 16px;
`

const Contact = styled.a`
  color: ${(props) => props.theme.colors.black400};
  text-align: center;
  display: block;
  margin-bottom: 4px;
`

const MobileNav = ({ data, pageContext, onNavigate }) => {
  const { locale } = pageContext
  const setLocaleInUrl = currentLocale !== locale ? `${locale}/` : ""
  const { sanityCompanyInfo } = data
  const destinations = data.allSanityVacancyCountry.edges.map((edge) => {
    const title = edge.node._rawLocaleTitle[locale]
      ? edge.node._rawLocaleTitle[locale]
      : ""
    return {
      title: title,
      internalLink: `/${setLocaleInUrl}${slugify(title)}`,
      flag: edge.node.flag,
    }
  })

  const tours = data.allSanityToursPage.edges.map((edge) => {
    const title = edge.node._rawLocaleTitle[locale]
      ? edge.node._rawLocaleTitle[locale]
      : ""
    const flag =
      edge.node.destination && edge.node.destination.flag
        ? edge.node.destination.flag
        : null
    const link = setLocaleInUrl
      ? `/${setLocaleInUrl}tours/${slugify(title)}`
      : `/tours/${slugify(title)}`
    return {
      title: title,
      internalLink: link,
      flag: flag,
    }
  })

  const destinationMenu = {
    title: localeData.DESTINATIONS[locale],
    items: destinations,
  }

  const toursMenu = {
    title: localeData.TOURS[locale],
    items: tours,
  }

  const navItems = [
    data.sanityAllVacanciesPage,
    toursMenu,
    destinationMenu,
    data.sanityOurProcessPage,
    data.sanityAboutUsPage,
    data.sanityStoriesPage,
    data.sanityFaqPage,
    data.sanityContactPage,
  ]

  return (
    <Container>
      {navItems.map((item) =>
        item.title && Array.isArray(item.items) ? (
          <MobileNavSubItems
            key={`${item.title}-m`}
            title={item.title}
            items={item.items}
            onClick={onNavigate}
          />
        ) : (
          <Item
            key={`${item.id}`}
            to={`/${setLocaleInUrl}${slugify(item._rawLocaleTitle[locale])}`}
            activeClassName="active"
            onClick={onNavigate}
          >
            {item._rawLocaleTitle[locale]}
          </Item>
        )
      )}
      <Footer>
        <Contact href={`tel:${sanityCompanyInfo.phone}`}>
          {sanityCompanyInfo.phone}
        </Contact>
        <Contact href={`mailto:${sanityCompanyInfo.email}`}>
          {sanityCompanyInfo.email}
        </Contact>
        <LanguageSelector locale={pageContext.locale} />
      </Footer>
      <ApplyNowDrawer locale={locale} />
    </Container>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query MobileNav {
        sanityAllVacanciesPage {
          id
          _rawLocaleTitle
        }
        sanityOurProcessPage {
          id
          _rawLocaleTitle
        }
        sanityAboutUsPage {
          id
          _rawLocaleTitle
        }
        sanityStoriesPage {
          id
          _rawLocaleTitle
        }
        sanityFaqPage {
          id
          _rawLocaleTitle
        }
        sanityContactPage {
          id
          _rawLocaleTitle
        }
        sanityCompanyInfo {
          phone
          email
        }
        allSanityVacancyCountry(sort: { fields: localeTitle___nl }) {
          edges {
            node {
              id
              _rawLocaleTitle
              flag {
                asset {
                  url
                }
              }
            }
          }
        }
        allSanityToursPage {
          edges {
            node {
              id
              _rawLocaleTitle
              destination {
                flag {
                  asset {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <MobileNav data={data} {...props} />}
  />
)
